import history from '~/services/history';
import notification from '~/services/notification';

import { formatMessage } from '~/i18n/translate';

import { resourceTypes, resulTypes } from './types';

export default class RoutesMiddleware {
  routeToDisplay(
    validations: string[] = [],
    { currentRole, extraValidation = true, requiredRoles }: resourceTypes,
    routeToVisit?: any
  ) {
    const resource = {
      currentRole,
      extraValidation,
      requiredRoles
    };

    const functions = {
      hasRequestedRole: () => this.hasRequestedRole(resource, routeToVisit)
    };

    let results: resulTypes | null = null;

    try {
      validations.map(() => {
        results = functions.hasRequestedRole();

        if (results?.status === false) {
          if (routeToVisit) {
            notification.warning(formatMessage('routesNotificationError401'));

            history.push('/');
          } else {
            return false;
          }
        }
      });

      if (routeToVisit) {
        return results?.component;
      } else {
        return results?.status;
      }
    } catch (e) {
      console.error(e);
    }
  }

  getRouteReturn(status, component) {
    return { status, component };
  }

  hasRequestedRole(resource: resourceTypes, component) {
    const { requiredRoles, currentRole, extraValidation } = resource;

    const hasRole = requiredRoles.length > 0 ? requiredRoles?.includes(currentRole ?? '') : true;

    const hasPermission = extraValidation && hasRole;

    return this.getRouteReturn(hasPermission, component);
  }
}
